import { Box } from '@mui/material';
import { Description, Root, StyledRadio, Title, TitleContainer } from './RadioButtonStyle';
import { isValidElement, ReactNode } from 'react';
import { RadioButtonVariant } from '../../types/radio';

interface RadioButton {
  value?: string | number | boolean;
  title?: ReactNode;
  description?: ReactNode;
  jsxContent?: JSX.Element;
  checked: boolean;
  variant?: RadioButtonVariant;
  onChange: () => void;
}

function RadioButton({
  title,
  description,
  jsxContent,
  checked,
  variant = RadioButtonVariant.DEFAULT,
  onChange,
  ...rest
}: RadioButton) {
  return (
    <Root {...rest} onClick={onChange} variant={variant} checked={checked}>
      <StyledRadio checked={checked} variant={variant} />
      <TitleContainer variant={variant}>
        {title &&
          (typeof title === 'string' ||
          (isValidElement(title) && title.props['data-formatted-message']) ? (
            <Title as='div' radioVariant={variant}>
              {title}
            </Title>
          ) : (
            <>{title}</>
          ))}
      </TitleContainer>
      {variant === RadioButtonVariant.DEFAULT && (
        <>
          {description && <Description as='div'>{description}</Description>}
          {jsxContent && <Box>{jsxContent}</Box>}
        </>
      )}
    </Root>
  );
}

export default RadioButton;
